import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import { Form } from 'antd';
import Dialog from '../../../core/layout/Dialog';
import Button from '../../../core/form/Button';

const ColorPaletteInput = (props) => {
  //https://uicolors.app/generate/55e02c link de site para pegar o objeto
  const [show, setShow] = useState(false);

  const handleToggleModal = () => {
    setShow(!show);
  };

  return (
    <div>
      <Form.Item
        required={props.required}
        colon={false}
        label={
          <>
            {props.label}{' '}
            <Button label="Update palette" onClick={handleToggleModal} size="sm" disabled={props.disabled} />
          </>
        }
        help={props.errorText}
        validateStatus={props.errorText && 'error'}
      >
        <div style={{ display: 'flex', columnGap: 8, alignItems: 'center', marginBottom: 16 }}>
          {Object.entries(props.value).map(([key, color]) => (
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: 4,
                backgroundColor: color,
                color: '#000000A',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
              key={color}
            >
              {key}
            </div>
          ))}
        </div>
      </Form.Item>
      <Dialog
        isOpen={show}
        onClose={handleToggleModal}
        title="Update palette"
        actions={[<Button icon="reload" label="Close" key="close" onClick={handleToggleModal} />]}
      >
        <TextInput
          label="json color"
          value={JSON.stringify(props.value)}
          textAreaRows="5"
          onChange={(value) => {
            try {
              let normalized = value.trim().replace(/'/g, '"'); // aspas simples -> duplas

              normalized = normalized.replace(/,\s*}/g, '}');
              normalized = normalized.replace(/,\s*]/g, ']');

              normalized = normalized
                .replace(/\s{2,}/g, ' ') // múltiplos espaços -> um espaço
                .replace(/{\s+/g, '{') // remove espaços após {
                .replace(/\s+}/g, '}') // remove espaços antes de }
                .replace(/:\s+/g, ':') // remove espaços após :
                .replace(/,\s+/g, ',') // remove espaços após ,
                .replaceAll('},}', '}}');

              // 4. Verifica se precisa envolver em chaves
              if (!normalized.startsWith('{') && !normalized.startsWith('[')) {
                normalized = '{' + normalized + '}';
              }
              if (normalized.endsWith('},}')) {
                normalized = normalized.replace('},}', '}}');
              }
              if (normalized.endsWith('},')) {
                normalized = normalized.replace('},', '}');
              }

              let palette = JSON.parse(normalized);
              while (!palette['50']) {
                palette = Object.entries(palette).at(0).at(1);
              }

              props.onChange(palette || {});
            } catch (error) {
              props.onChange({});
            }
          }}
          fieldType="textarea"
        />
      </Dialog>
    </div>
  );
};

const WhitelabelConfigColorPaletteForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={12}>
        <ColorPaletteInput
          label="Primary color"
          disabled={props.submitting}
          value={get(props.values, 'primaryColorPalette', {})}
          onChange={(value) => props.onChange('primaryColorPalette', value)}
          errorText={get(props.errors, 'primaryColorPalette', null)}
        />
      </Column>
      <Column size={12}>
        <ColorPaletteInput
          label="Accent color"
          disabled={props.submitting}
          value={get(props.values, 'accentColorPalette', {})}
          onChange={(value) => props.onChange('accentColorPalette', value)}
          errorText={get(props.errors, 'accentColorPalette', null)}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel="Update color palette"
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

WhitelabelConfigColorPaletteForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

WhitelabelConfigColorPaletteForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default WhitelabelConfigColorPaletteForm;
